export default __webpack_public_path__ + "0beb0a629d87858d1aa4d57be01f9a27.png";